import React from "react";
import {
  ContentNotification,
  ListNotification,
  Title,
  List,
  Item,
  Icon,
  TitleItem,
  DescItem,
  CleanNotification,
  ButtonCleanNotification,
  // Construcao,
} from "./styles";
import ListIcon from "@mui/icons-material/List";
import useEventListener from "../../hooks/useEventListener";

/**
 * @param props
 * @param {Boolean} props.show
 * @param {Function} props.onShow
 */
export default function Notification({ show = false, onShow = () => null }) {
  const notificationRef = React.useRef();

  useEventListener("mousedown", (event) => {
    if (event.defaultPrevented) return;
    if (notificationRef?.current === event.target) onShow();
  });

  return (
    show && (
      <ContentNotification ref={notificationRef}>
        <ListNotification>
          <Title>Notificações</Title>
          <List>
            <Item
              title="Testando a lista de Notificações"
              to="/dashboard/notification/150"
              onClick={() => onShow()}
            >
              <Icon>
                <ListIcon style={{ fontSize: "50px" }} />
              </Icon>
              <TitleItem>Lista</TitleItem>
              <DescItem>Testando a lista de Notificações</DescItem>
            </Item>
          </List>
          {/* <Construcao>
        <h1> Em construção </h1>
      </Construcao> */}
          <CleanNotification>
            <ButtonCleanNotification title="Marcar todas como lidas">
              Marcar todas como lidas
            </ButtonCleanNotification>
          </CleanNotification>
        </ListNotification>
      </ContentNotification>
    )
  );
}
